export default function scrollToElementId(elementId) {
  setTimeout(async () => {
    const element = document.getElementById(elementId);
    await element?.scrollIntoView({ behavior: 'smooth' });
  }, 100);
}
